import UIButton from 'UIComponents/button/UIButton';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { reloadWindow } from '../../thread-list-member/operators/reloadWindow';
import { trackEvent } from '../../usage-tracking/clients/usageTracker';
import { getClickedRefreshInboxButton, getClosedRefreshInboxPrompt, getShowRefreshInboxPrompt } from 'conversations-inbox-lib/usage-tracking/inboxInteractionEvents';
import { useWorkspaceVersionCheck } from 'svh-workspace-ui-lib/refresh/hooks/useWorkspaceVersionCheck';
import { useEffect } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const RefreshInboxBanner = () => {
  const {
    shouldPrompt,
    setShouldPrompt
  } = useWorkspaceVersionCheck('Inbox');
  const handleReloadWindow = () => {
    trackEvent(getClickedRefreshInboxButton());
    reloadWindow();
  };
  const handleCloseBanner = () => {
    trackEvent(getClosedRefreshInboxPrompt());
    setShouldPrompt(false);
  };
  useEffect(() => {
    if (shouldPrompt) {
      trackEvent(getShowRefreshInboxPrompt());
    }
  }, [shouldPrompt]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: shouldPrompt && /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(UIAlert, {
        type: "warning",
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "conversations-inbox-ui.banners.refreshInbox.title"
        }),
        closeable: true,
        onClose: handleCloseBanner,
        children: /*#__PURE__*/_jsxs(UIButtonWrapper, {
          children: [/*#__PURE__*/_jsx("span", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "conversations-inbox-ui.banners.refreshInbox.pleaseRefresh"
            })
          }), /*#__PURE__*/_jsx(UIButton, {
            size: "small",
            use: "tertiary",
            onClick: handleReloadWindow,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "conversations-inbox-ui.banners.refreshInbox.refreshButton"
            })
          })]
        })
      })
    })
  });
};
RefreshInboxBanner.displayName = 'RefreshInboxBanner';
export default RefreshInboxBanner;